import FFCLogo from "../../../assets/images/logos/ffc-short-logo-upd.png";

const BrandLogo = () => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        // marginTop: "10px",
        marginBottom: "50px",
      }}
    >
      {/* <div
        style={{
          // backgroundColor: "#fff",
          width: "10rem",
          height: "10rem",
          borderRadius: "50%",
          overflow: "hidden",
          padding: "0.8rem",
        }}
      > */}
      <a href="/" rel="noreferrer">
        <img
          style={{
            objectFit: "contain",
            width: "80%",
          }}
          src={FFCLogo}
          alt="FFC"
        />
      </a>
      {/* </div> */}
    </div>
  );
};

export default BrandLogo;
